import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgCollection = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="m8.276 7.825-6.42.93-.113.024A1 1 0 0 0 1.3 10.46l4.652 4.547-1.11 6.319-.014.106a1 1 0 0 0 1.469.95l5.701-3.04 5.703 3.04.097.045a1 1 0 0 0 1.359-1.1l-1.104-6.32L22.7 10.46l.078-.085a1 1 0 0 0-.634-1.619l-6.386-.931-2.863-5.77a1 1 0 0 0-1.794.005L8.276 7.825Zm3.728-3.064L14.2 9.183l.06.106a1 1 0 0 0 .691.44l4.906.715-3.577 3.504-.083.091a1 1 0 0 0-.203.795l.841 4.82-4.365-2.327-.113-.051a1 1 0 0 0-.828.051l-4.362 2.324.847-4.815.014-.122a1 1 0 0 0-.3-.767l-3.582-3.502 4.94-.717a1 1 0 0 0 .755-.55l2.163-4.417Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgCollection)
const Memo = memo(ForwardRef)
export default Memo
